module.exports = __webpack_public_path__ + "static/sf-ui-bold-3ae936e1b679d929d9ac87eb817c82a9.woff";